
'use strict'

//burger menu 
var existOverview = document.getElementsByClassName('menu__burger');
if (existOverview.length > 0) {
const navSlide = () => {
	const burger = document.querySelector(".menu__burger");
	const nav = document.querySelector(".navlink");

	burger.addEventListener('click',()=>{
		nav.classList.toggle('nav-active');
		burger.classList.toggle('toggle');
	});
}

navSlide();

}

//scroll animations
var controller = new ScrollMagic.Controller();


var scene = new ScrollMagic.Scene({

		triggerElement: '.box1',
		reverse: false


	})

	.setClassToggle('.box1', 'fade-in')
	.addTo(controller);


var scene2 = new ScrollMagic.Scene({

		triggerElement: '.box2',
		reverse: false

	})

	.setClassToggle('.box2', 'fade-inX')
	.addTo(controller);


var scene3 = new ScrollMagic.Scene({

		triggerElement: '.box3',
		reverse: false

	})

	.setClassToggle('.box3', 'fade-inX')
	.addTo(controller);


var scene4 = new ScrollMagic.Scene({

		triggerElement: '.box4',
		reverse: false
	})

	.setClassToggle('.box4', 'fade-in')
	.addTo(controller);

var scene5 = new ScrollMagic.Scene({

		triggerElement: '.box5',
		reverse: false


	})

	.setClassToggle('.box5', 'fade-inX')
	.addTo(controller);


var scene6 = new ScrollMagic.Scene({

		triggerElement: '.box6',
		reverse: false


	})

	.setClassToggle('.box6', 'fade-inX')
	.addTo(controller);


var scene7 = new ScrollMagic.Scene({

		triggerElement: '.box7',
		reverse: false


	})

	.setClassToggle('.box7', 'fade-inX')
	.addTo(controller);


var scene8 = new ScrollMagic.Scene({

		triggerElement: '.box8',
		reverse: false


	})

	.setClassToggle('.box8', 'fade-in')
	.addTo(controller);







    anime({
        targets: '#eau1',

        translateY:20,
        easing: 'linear',
        loop: true,
        direction: 'alternate',
        duration:1200

    });



        anime({
        targets: '#bateau1',


        rotate:[{value: -2}, {value:2}],
        translateX:20,
        translateY: 20,
        direction: 'alternate',
        easing: 'linear',
        loop: true,
        

    });

        
//animation page (windows onload)
var existOverview = document.getElementsByClassName('animate-container');
if (existOverview.length > 0) {

        const anim = document.querySelector(".animate-container");
        const animIMAGE = document.querySelector(".animate-image");
       
        window.onload = function() {
            anim.classList.add('animload');
            animIMAGE.classList.add('anim-image');
        }

//animation page (foreach link : onclick)
     const link = document.querySelectorAll('.linktransition').forEach(link =>{

           link.addEventListener('click', function(e) {

              anim.classList.add('animload-reverse');
              animIMAGE.classList.add('anim-image-reverse');


            const lien = this.href;
            document.body.addEventListener('animationend', function() {

                window.location = lien;
            });
            e.preventDefault();

        });


                });

}



 
var existOverview = document.getElementsByClassName('flex-img-game');
if (existOverview.length > 0) {

    const modalerror = document.querySelector('#modal-error');
    const modalpeinture = document.querySelector('#modal-peinture');
    const modalinfos = document.querySelector('#modal-infos');
    const btninfos = document.querySelector('#btn-infos');
    const btnplus = document.querySelector('#btn-plus');
    const close = document.querySelector('.close');
    const ok = document.querySelector('#ok');
    const animation = document.querySelector('.animation');
    const start = document.querySelector('#start');
    const win1 = document.querySelector('#win1');
    const win2 = document.querySelector('#win2');
    const win3 = document.querySelector('#win3');
    const win4 = document.querySelector('#win4');
    const win5 = document.querySelector('#win5');


//Compteur --
    var click = 0;
    var outOfTime = false;
    var time = 60 * 2;

    start.addEventListener("click", function(event) {
        if (event.currentTarget.getAttribute("data-disable") == 1) {
            return;
        }
        event.currentTarget.setAttribute("data-disable", 1);

        disnone.play()

      var timer = setInterval(function(){
            time--;
            document.getElementById("timer").innerHTML = time + "s ";
            if (time == 0) {
                clearInterval(timer);
                modalerror.style.display = 'unset';
                anime.restart;
                outOfTime = true;
            } else if (click == 5) {
                clearInterval(timer);
               setTimeout(function() {
                     btnplus.style.display = 'block';
                }, 3700);
                animation.style.display = 'block';
                anim1.play();
                anim2.play();
                anim3.play();
                anim4.play();
                anim5.play();
                anim6.play();

                setTimeout(function() {
                    animation.style.display = 'none';
                }, 2500);

                setTimeout(function() {
                    modalpeinture.style.display = 'block';
                }, 2500);

                outOfTime = true;
            }

       },1000);

        });




     //MODALS Open && Close

    // Events
    btninfos.addEventListener('click', openModal);
    ok.addEventListener('click', closeModalInfos);
    close.addEventListener('click', closemodalpeinture);
    btnplus.addEventListener('click', openmodalpeinture);
    window.addEventListener('click', outsideClick);

    // Open
    function openModal() {
        modalinfos.style.display = 'unset';
    }

    // Close
    function closeModalInfos() {
        modalinfos.style.display = 'none';
    }

     function closemodalpeinture() {
        modalpeinture.style.display = 'none';
    }


     function openmodalpeinture() {
        modalpeinture.style.display = 'block';
    }


    // Close If Outside Click
    function outsideClick(e) {
        if (e.target == modalinfos) {
            modalinfos.style.display = 'none';
        }
    }




        // Error click function
        let fooElement01 = document.querySelector("#error1");
        fooElement01.addEventListener("click", (event) => {


            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win1.style.display = 'block';
                winanim1.play()
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });
        
        // Error click function
        let fooElement02 = document.querySelector("#error2");
        fooElement02.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win2.style.display = 'block';
                winanim2.play()

                document.getElementById("score").innerHTML = 'erreurs = ' + click;
                event.currentTarget.setAttribute("data-disable", 1);
            }

        });


        // Error click function
        let fooElement03 = document.querySelector("#error3");
        fooElement03.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win4.style.display = 'block';
                winanim4.play()
                document.getElementById("score").innerHTML = 'erreurs = ' + click;

            }
            event.currentTarget.setAttribute("data-disable", 1);

        });


        // Error click function
        let fooElement04 = document.querySelector("#error4");
        fooElement04.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win5.style.display = 'block';
                winanim5.play()
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });


        // Error click function
        let fooElement05 = document.querySelector("#error5");
        fooElement05.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win3.style.display = 'block';
                winanim3.play()
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });



         // Animation Svg
         
    anime({
        targets: '.smartphone img',
rotate: [{
                value: 0
            },
            {
                value: -90,
                duration: 1000
            }
        ],
        loop: true

    });





        var disnone = anime({
        targets: '#start',
        translateX: [{
                value: 0
            },
            {
                value: -500,
                duration: 3100
            }
        ],
        easing: 'easeInOutCirc',
        autoplay: false

    });


        var anim1 = anime({
        targets: '.lettre',
        translateY: [{
                value: 200,
                duration: 250
            },
            {
                value: 0,
                duration: 300
            }
        ],
        scale: [{
                value: 0.5,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        opacity: [{
                value: 0,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        delay: function(el, i, l) {
            return i * 293
        },
        autoplay: false


    });



         var anim2 = anime({
        targets: 'path.st4',
        d: [{
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
            {
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
            {
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
        ],
        easing: 'easeOutQuad',
        duration: 2200,
        autoplay: false
    });

    var anim3 = anime({
        targets: 'path.st6',
        d: [{
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
            {
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
            {
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
        ],
        easing: 'easeOutQuad',
        duration: 2200, 
        autoplay: false

    });




    var anim4 = anime({
        targets: '#ombre_visage',
        translateY: [{
                value: -15,
                duration: 450
            },
            {
                value: 0,
                duration: 450
            },
            {
                value: -15,
                duration: 450
            },
            {
                value: 0,
                duration: 450
            },
            {
                value: -15,
                duration: 310
            },
        ],
        easing: 'easeOutQuad',
        delay: 235,
        autoplay: false
    });


    var anim5 = anime({
        targets: '#pomme',
        translateY: [{
            value: -150,
            duration: 2000
        }, ],
        easing: 'easeOutQuad',
        loop: false,
        delay: 340,
        autoplay: false
    });

    var anim6 = anime({
        targets: '.animation__magritte',
        scale: [{
            value: 1.1,
            duration: 500
        }, ],
        opacity: [{
            value: 1,
            duration: 500
        }, ],
        easing: 'easeOutQuad',
        loop: false,
        delay: 200,
        autoplay: false

    });


        var winanim1 = anime({
        targets: '#win1',
        translateY: [

             { 
        	value: -20,

        	 },

              { 
        	value: 0,
        	duration:140,

        	 },



         ],

        opacity:1,
        easing: 'easeInOutQuint',
        loop: false,
        autoplay: false

    });


      var winanim2 = anime({
        targets: '#win2',
        translateY: [

             { 
        	value: -20,

        	 },

              { 
        	value: 0,
        	duration:140,

        	 },



         ],

        opacity:1,
        easing: 'easeInOutQuint',
        loop: false,
        autoplay: false

    });


    var winanim3 = anime({
        targets: '#win3',
        translateY: [

             { 
        	value: -20,

        	 },

              { 
        	value: 0,
        	duration:140,

        	 },



         ],

        opacity:1,
        easing: 'easeInOutQuint',
        loop: false,
        autoplay: false

    });


        var winanim4 = anime({
        targets: '#win4',
        translateY: [

             { 
        	value: -20,

        	 },

              { 
        	value: 0,
        	duration:140,

        	 },



         ],

        opacity:1,
        easing: 'easeInOutQuint',
        loop: false,
        autoplay: false

    });



        var winanim5 = anime({
        targets: '#win5',
        translateY: [

             { 
        	value: -20,

        	 },

              { 
        	value: 0,
        	duration:140,

        	 },



         ],

        opacity:1,
        easing: 'easeInOutQuint',
        loop: false,
        autoplay: false

    });



}












 